import { downloadFile } from '../../../shared/api/download';

/** На бэке путь именно такой — с опечаткой в расширении. */
const TEMPLATE_PATH = '/api/reports/sample.xslx';

export function downloadPositionsTemplate(): Promise<void> {
    return downloadFile(TEMPLATE_PATH, 'Шаблон заявки для сервиса предиктивной аналитики.xlsx');
}